import { useMutation, useQueryClient } from "@tanstack/react-query";
import _, { findWhere } from "underscore";
import useCloudPermissions from "../../../hooks/useCloudPermissions";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import { View } from "../../../types/PageInterfaces";
import { PageView } from "../../../types/GlobalInterfaces";
import PageAPI from "../../api/PageAPI";
import { useAtomValue } from "jotai";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";

const useReorderSubViews = () => {
  const client = useQueryClient();
  const workspaceID = useAtomValue(workspaceIdAtom);
  const { cPermissions } = useCloudPermissions();

  const reorderTabs = useMutation({
    mutationFn: ({
      pageID,
      parentViewID,
      newOrder,
    }: {
      pageID: string;
      parentViewID: string;
      newOrder: any;
    }) => {
      if (false) {
        Promise.reject("You do not have permission to reorder these views");
      }

      return PageAPI.reorderSubviews(
        workspaceID,
        pageID,
        parentViewID,
        newOrder
      );
    },
    onMutate: ({ parentViewID, newOrder }) => {
      if (!cPermissions.cloud_modify_template) return;

      const previousView = client.getQueryData<View>(["view", parentViewID]);

      if (!previousView) {
        return console.error("Failed to find View.");
      }

      const newView = structuredClone(previousView);
      const newSubViews: PageView[] = [];

      if (!newView?.SubViews) {
        return console.error("No views to reorder.");
      }

      for (const id of newOrder) {
        const subView = findWhere(newView.SubViews, { id });

        subView && newSubViews.push(subView);
      }

      if (newView?.SubViews?.length !== newSubViews.length) {
        return console.error("Missing View on Reorder.");
      }

      newView.SubViews = newSubViews;

      client.setQueryData(["view", parentViewID], newView);

      // Return previous schema in case of error.
      return { previousView };
    },
    onError: (err, { parentViewID }, context) => {
      console.log(getErrorMessage(err));
      if (context) {
        client.setQueryData(["view", parentViewID], context.previousView);
      }
    },
  });

  return {
    reorderTabs: reorderTabs.mutate,
    reorderingTabs: reorderTabs.isPending,
    reorderTabsError: reorderTabs.error
      ? getErrorMessage(reorderTabs.error)
      : null,
  };
};

export default useReorderSubViews;
